import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class SignoSeguridadService {

    accesoDenegado = false;

    private readonly EMAILS_SEGURIDAD: string[] = [
        'daniloklimczuk@uoetsylra.org',
        'soporte1@uoetsylra.org',
        'prensa@uoetsylra.org',
        'ramossistemas@gmail.com',
        'm.adrian.torres@gmail.com',
        'naumannthostrupivan@gmail.com',
    ];

    constructor(
        private authService: AuthService,
    ) {}

    async puedeAccederSeguridad(): Promise<boolean> {
        const user = await this.authService.getUserLogon();
        const email = (user?.email || '').trim().toLowerCase();
        return this.EMAILS_SEGURIDAD.includes(email);
    }

    setAccesoDenegado(valor: boolean): void {
        this.accesoDenegado = valor;
    }

    async puedeAccederMenues(): Promise<boolean> {
        const user = await this.authService.getUserLogon();
        const email = (user?.email || '').trim().toLowerCase();
        return email === 'naumannthostrupivan@gmail.com';
    }
}
